import { Component, OnInit, Input } from '@angular/core';
import { faPlus, faTimes} from '@fortawesome/pro-light-svg-icons';
import {AddFundComponent} from  '../case-funds/add-fund/add-fund.component';
import { CaseFundsService } from '../../../shared/services/case-funds.service';
import { ComparerService } from '../../../shared/utility/comparer';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { YesNoPopupComponent } from 'src/app/shared/components/yes-no-popup/yes-no-popup.component';
import { ModalService } from 'src/app/shared/services/modal.service';

@Component({
  selector: 'app-case-funds',
  templateUrl: './case-funds.component.html',
  styleUrls: ['./case-funds.component.scss']
})
export class CaseFundsComponent implements OnInit {

  @Input() caseId: number = -1;

  caseFunds: any[] = [];
  initialCaseFunds: any[] = []; // To be used to check for any changes
  faPlus = faPlus;
  faTimes= faTimes;
  firstLoad = true;

  caseFundsTotal: number = 0;

  constructor(public activeModal: NgbActiveModal,
              private caseFundsService: CaseFundsService,
              private comp: ComparerService,
              private modalService: ModalService) {
  }

  ngOnInit(): void {
    this.loadCaseFunds();
  }

  loadCaseFunds(){
    this.caseFundsService.getCaseFunds( this.caseId).subscribe((response : any) => {
      this.caseFunds = response.caseFunds;

      if(this.firstLoad)
        this.initialCaseFunds = this.caseFunds;

      this.firstLoad = false;

      this.caseFundsTotal = 0;
      this.caseFunds.forEach( (fund:any) => {
        this.caseFundsTotal += fund.net;
      });
    });
  }

  addFund(){

    const modalRef = this.modalService.openWithOptions(AddFundComponent, {size: 'md'});
    modalRef.componentInstance.caseId = this.caseId;

    modalRef.result.then(
      (result) => {
        if(result)
        {
            this.loadCaseFunds();
        }
    },
      () => {} // dismissed - do nothing
    ); 

  }

  removeFund(id: number){

      const modalRef = this.modalService.openWithOptions(YesNoPopupComponent, {size: 'lg'});
             
        modalRef.componentInstance.messageHeader = 'Are you sure you want to remove this fund?';
        modalRef.componentInstance.popupText1 = '';
        modalRef.componentInstance.popupText2 = '';
    
        modalRef.result.then(
          (result) => {
            if(result)
            {
              this.caseFundsService.removeCaseFund( this.caseId, id ).subscribe((response : any) => {
                this.loadCaseFunds();
              });
            }
        },
      () => {} // dismissed - do nothing
    );
  }

  close(){

    if(this.comp.objectsDifferent(this.caseFunds, this.initialCaseFunds)) // check if objs are different
    {
      this.caseFundsService.emailParalegal(this.caseId).subscribe((response : any) => {

        this.activeModal.close(true);
      });
    }
    else{
      this.activeModal.dismiss();
    }
     
  }

}
